import { Select, Td } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { DocumentCategory } from "../../autogen/bff-api";
import { DOCUMENT_CATEGORY_ORDER, useDocumentCategoryLabel } from "./useDocumentCategoryLabel";

export const DocumentCategoryCell = ({
  category,
  canEdit,
  onChange,
}: {
  category?: DocumentCategory | null;
  canEdit: boolean;
  onChange?: (category: DocumentCategory | null) => void;
}) => {
  const { t } = useTranslation();
  const documentCategoryLabel = useDocumentCategoryLabel();

  return (
    <Td onClick={(e) => e.stopPropagation()}>
      {canEdit ? (
        <Select
          size="sm"
          rounded="md"
          value={category ?? ""}
          aria-label={t("document category") ?? "document category"}
          onChange={(e) => {
            if (e.target.value !== "") onChange?.(e.target.value as DocumentCategory);
          }}
        >
          <option value="" disabled={!!category}>
            {t("Select category")}
          </option>
          {DOCUMENT_CATEGORY_ORDER.map((cat) => (
            <option key={cat} value={cat}>
              {documentCategoryLabel(cat)}
            </option>
          ))}
        </Select>
      ) : category ? (
        documentCategoryLabel(category)
      ) : (
        "-"
      )}
    </Td>
  );
};
